// extracted by mini-css-extract-plugin
export default {"unreadIndicator":"styles-module__unreadIndicator__a40f58a86bf8374659b2"};